import Header from './Header';

// export types
export type { HeaderProps } from './Header';

// export components
export { Header };
export default Header;
